import { render, staticRenderFns } from "./settlementDatail.vue?vue&type=template&id=5676a0ea&scoped=true&"
import script from "./settlementDatail.vue?vue&type=script&lang=js&"
export * from "./settlementDatail.vue?vue&type=script&lang=js&"
import style0 from "./settlementDatail.vue?vue&type=style&index=0&id=5676a0ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676a0ea",
  null
  
)

export default component.exports